import React from 'react';
import { Box, Heading, Text, UnorderedList, ListItem, OrderedList, Link } from '@chakra-ui/react';

export const BowlingPinMatch = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        <strong>Contact:</strong> Craig Smith (<Link href="mailto:GGCpinmatch@gmail.com" color="blue.500">GGCpinmatch@gmail.com</Link>) to reserve your spot for each match or with questions.
      </Text>

      <Text mb={4} color="black">
        One part drag race, one part bowling, one part practical accuracy ... A bowling pin shoot is a head to head, double elimination, competition where shooters race each other, using a handgun, to knock all the bowling pins off the table before your opponent.
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><strong>When:</strong> See Club Calendar For Schedule.</ListItem>
        <ListItem><strong>Time:</strong> Summer (Apr-Sep): Practice is at 8:00 AM; Matches start at 9:00 AM. Winter (Oct-Mar): Practice is at 9:00 AM; Matches start at 10:00 AM.</ListItem>
        <ListItem><strong>Fees:</strong> GGC members $10, Non Members $15. $10 for pin replacement, equipment repair & maintenance.</ListItem>
        <ListItem><strong>Limit:</strong> 16 shooters per match.</ListItem>
      </UnorderedList>

      <Heading as="h3" size="md" mb={3} color="black">Match Procedures</Heading>

      <Heading as="h4" size="sm" mb={3} color="black">Equipment Rules</Heading>
      <OrderedList spacing={2} ml={6} mb={4}>
        <ListItem>Calibers 9mm to .45 Auto.</ListItem>
        <ListItem>Handguns only.</ListItem>
        <ListItem>Allowed 2 x 8 round magazines or as many magazines as it takes to equal 16 rounds total. 6 round revolver shooters will have the option of shooting 6 pin tables and have a max loadout of 12 rounds per stage.</ListItem>
        <ListItem>No laser sights that project anything onto the target.</ListItem>
        <ListItem>ALL competitors must have a current Liability Wavier on file with the Golden Gun Club in order to participate. These must be updated annually- on line or at the club house.</ListItem>
      </OrderedList>

      <Heading as="h4" size="sm" mb={3} color="black">Match Description</Heading>
      <Text mb={4} color="black">
        Matches will start with a brief safety meeting after which everyone will be randomly placed in a bracket. Shooters will be called by name to compete against each other in a head to head, double elimination bracket. Winners will be determined by who knocks their pins completely off the table before their opponent. The winner of each round will be advanced in the winners' bracket and loser will be moved to a losers' bracket. You will compete until you have lost twice. Shooters may be given reduced number of pins to "handicap" their match based on skill level.
      </Text>
    </Box>
  );
};